import { GET_PROFILE, CLEAR_CURRENT_USER, PROFILE_LOADING } from "../type";

const initialState = {
	profile: null,
	loading: false,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case PROFILE_LOADING:
			return {
				...state,
				loading: true,
			};
		case GET_PROFILE:
			return {
				...state,
				loading: false,
				profile: action.payload,
			};
		case CLEAR_CURRENT_USER:
			return {
				...state,
				profile: null,
			};
		default:
			return state;
	}
}
